import { Pipe, PipeTransform } from "@angular/core";
import { CertificationStatus } from "@app/training/training.models";

@Pipe({ name: "certStatusName" })
export class CertStatusNamePipe implements PipeTransform {
	transform(status: CertificationStatus): string {
		return CertificationStatus.getPrettyName(status);
	}
}
